import { createSelector } from 'reselect'
import { RootState } from '../../../store'

const getWaterSystemCoordinatesData = (state: RootState) => state.waterSystemCoordinates.data

const selectWaterSystemCoordinates = (state: RootState) => state.waterSystemCoordinates.data.items
const selectInvalidIdx = (state: RootState) => state.waterSystemCoordinates.data.invalidIdx
const selectBoundingBox = (state: RootState) => state.waterSystemCoordinates.data.boundingBox

const error = (state: RootState) => state.waterSystemCoordinates.error
const loading = (state: RootState) => state.waterSystemCoordinates.loading
const success = (state: RootState) => state.waterSystemCoordinates.success

const makeSortedCoordinates = createSelector(
  [selectWaterSystemCoordinates, (state: RootState, sortOrder: string) => sortOrder],
  (coordinates, sortOrder: string) => {
    if (!coordinates) return []

    return [...coordinates].sort((a, b) => {
      const aPopulationServed = a.POPULATION_SERVED_COUNT || 0
      const bPopulationServed = b.POPULATION_SERVED_COUNT || 0

      return sortOrder === 'highest'
        ? bPopulationServed - aPopulationServed
        : aPopulationServed - bPopulationServed
    })
  },
)

export const WaterSystemCoordinatesSelector = {
  getWaterSystemCoordinatesData,
  selectWaterSystemCoordinates,
  selectInvalidIdx,
  selectBoundingBox,
  error,
  loading,
  success,
  makeSortedCoordinates,
}
